export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7043.28547b27.jpg";